export default __webpack_public_path__ + "bf9aa8ccfa7e8832205e11d261814c26.jpg";